import { ListItem } from "@mui/material";
import { FaFileDownload } from "react-icons/fa";
import styled from "styled-components";

export const ContainerPictures = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: auto;
  overflow: visible;
  margin: 25px 0;
  padding: 0 50px;

  a {
    color: #000;
  }
`;

export const StyledListItem = styled(ListItem)`
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #eee;

  .MuiListItemText-primary {
    font-weight: 500;
  }

  .MuiListItemText-secondary {
    font-size: 0.85rem;
    color: #666;
  }
`;

export const DownloadIcon = styled(FaFileDownload)`
  margin-left: 12px;
  color: #007bff;
`;

export const PDFViewer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 500px;
  max-height: 70vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; // Para scroll suave no iOS
  margin: 0 auto;
  padding: 16px 0;

  .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .react-pdf__Page {
    margin: 8px 0;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 600px) {
    max-height: 60vh;
  }
`;
export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 20px;
`;

export const ErrorContainer = styled.div`
  padding: 20px;
  background-color: #ffebee;
  border-radius: 4px;
  margin-top: 20px;
`;

export const BoxButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
`;

export const BoxTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
`;

export const PDFContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 570px;
  gap: 16px;
  padding: 8px;
`;

export const PaginationControls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 16px;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 8px;
  width: 100%;

  @media (max-width: 600px) {
    gap: 12px;
    flex-direction: column;
  }
`;
